<template lang="pug">
header(class='Container')
	div(class='Header', :class='{ "Header--Main": isMainPage }')
		Logo(v-if='showHeaderLogo', class='Logo')

		HeaderCity

		HeaderNavigation(v-if='greaterThan("desktop")')

		HeaderContacts

		UiToggleMenu(v-if='lessThan("desktopMedium")')

		Transition(name='slide')
			MobileMenu(v-if='lessThan("desktopMedium") && menuToggle')

	MobileHeaderLogo(v-if='lessThan("mobileWide")')
</template>

<script lang="ts" setup>
const { lessThan, greaterThan } = usePlatform();
const { menuToggle } = useMenu();

const route = useRoute();

const isMainPage = computed(() => route.path === '/');

const showHeaderLogo = computed(
	() =>
		(!isMainPage.value && greaterThan('desktop')) ||
		(greaterThan('mobileMedium') && lessThan('desktopMedium'))
);
</script>

<style lang="less" scoped>
.Header {
	padding: 1rem 0;
	.relative(99999);
	.box(grid; 100%; auto; none; 1rem; 1fr; 1fr auto; center; center; column);

	& > .Logo {
		.grid(1 span; 1 span; center; start);
		.box(auto; 1.875rem);
	}

	& > .City {
		.grid(1 span; 1 span; center; start);
	}

	& > .Navigation {
		.grid(1 span; 1 span; center; start);
	}

	& > .Contacts {
		.grid(1 span; 1 span; center; start);
	}

	& > .ToggleMenu {
		.grid(1 span; 1 span; center; end);
	}

	/**
	* >= 600px
	*/
	@media all and (min-width: @tablet-small) {
		.gridbox-col(auto 1fr auto);

		& > .City {
			padding-right: 0.25rem;
			padding-left: 0.25rem;
		}
	}

	/**
	* >= 1200px
	*/
	@media all and (min-width: @desktop) {
		padding: 1.25rem 0;

		&.Header--Main {
			.gridbox-col(auto 1fr auto);
		}

		&:not(.Header--Main) {
			.gridbox-col(auto auto 1fr auto);
			& > .Logo {
				.box(8.3125rem; auto);
			}
		}
	}

	/**
	* >= 1400px
	*/
	@media all and (min-width: @large-screen) {
		& > .City {
			padding-right: 1rem;
			padding-left: 1rem;
		}
	}
}
</style>
